

import React, { useMemo, useRef } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { useCertificateTypes } from "../../hooks/useCertificateTypes.js";
import mems from "../../assets/mems.jpg";
import badge from "../../assets/badges.png";
const CertificateGenerator = ({
  name,
  type,
  duration,
  competition,
  internship,
  certificateId,
}) => {
  const certificateRef = useRef(null);
  const certificateTypes = useCertificateTypes() || {};
  const cert = certificateTypes[type] || {};
  const fullCertificateId = certificateId || "";

  // Extract the short ID for display
  const displayCertificateId = useMemo(() => {
    if (!fullCertificateId) return "";
    return fullCertificateId.split("-").slice(-1)[0];
  }, [fullCertificateId]);

  const issueDate = useMemo(() => {
    return new Date().toLocaleDateString("en-GB");
  }, []);

  const formattedDescription = useMemo(() => {
    if (!cert.description) return "";
    return cert.description.replace("{subject}", competition || internship || "the designated program");
  }, [cert, competition, internship]);

  if (!cert.title) return <div ref={certificateRef} className="hidden" />;

  return (
    <div 
      ref={certificateRef} 
      className="bg-gray-100 flex items-center justify-center"
      style={{ width: '1200px', height: '850px', overflow: 'hidden' }} 
    >
      {/* 🏛️ MAIN BOX */}
      <div 
        className="w-[1100px] h-[750px] bg-white border-[12px] border-indigo-600 relative flex flex-col items-center shadow-2xl"
        style={{ boxSizing: 'border-box' }}
      >
      

{/* --- HEADER: LOGOS --- */}
<div className="w-full px-12 pt-6 flex justify-between items-start">

  {/* LEFT SIDE - TEXT BRANDING */}
  <div className="flex flex-col leading-none -translate-y-4 -translate-x-4">
    
    <h1 className="text-4xl font-serif font-bold tracking-wide text-gray-900">
      GenZ <span className="text-indigo-700">Evaluation</span>
    </h1>

    <p className="text-[10px] tracking-[0.5em] text-indigo-600 uppercase mt-3">
      Built For The Bold
    </p>

  </div>

  {/* RIGHT SIDE - MSME */}
  <img 
    src={mems} 
    alt="MSME UDYAM"
    className="w-44 object-contain -translate-y-4 translate-x-4"
  />

</div>


{/* --- contents --- */}
<div className="flex-1 flex flex-col items-center justify-center text-center px-24">

  <h1 className="text-2xl font-serif font-bold text-gray-800 tracking-[0.3em] uppercase">
    {cert.title}
  </h1>

  <div className="w-40 h-[2px] bg-indigo-600 my-6"></div>

  {/* 🏆 WINNER BADGE (Floating, No Layout Break) */}
{type === "WINNER" && badge && (
  <div className="absolute top-[150px] right-[70px] pointer-events-none">
    <img
      src={badge}
      alt="Winner Badge"
      className="w-24 h-24 object-contain opacity-70 saturate-75  blur-[0.3px]"
      style={{ filter: 'drop-shadow(0px 6px 10px rgba(0,0,0,0.15))' }}
    />
  </div>
   )} 

  <p className="text-base font-serif tracking-[0.35em] uppercase text-gray-500 mb-4">
    {cert.subtitle}
  </p>

  <h2
    className="text-6xl text-indigo-800 my-6"
    style={{
      fontFamily: "'Great Vibes', cursive",
      letterSpacing: "0.05em"
    }}
  >
    {name}
  </h2>

  <p className="text-lg font-serif text-gray-700 max-w-3xl leading-relaxed mt-4">
    {formattedDescription}
  </p>


   {/* 📅 INTERNSHIP DURATION (Only if exists) */}
{duration && (
  <p className="mt-4 text-base font-serif text-gray-600 tracking-wide">
    Duration: {duration} month{duration > 1 ? "s" : ""}
  </p>
  )}

</div>

<div className="w-full px-16 pb-12 flex justify-between items-end">

  {/* DATE */}
  <div className="text-center w-48">
    <p className="font-serif text-xl text-gray-900 border-b border-gray-300 pb-1">
      {issueDate}
    </p>
    <p className="text-[9px] text-gray-500 uppercase font-bold tracking-[0.25em] mt-3">
      Date of Issue
    </p>
  </div>

  {/* SIGNATURE */}
  <div className="text-center w-60">

  {/* Name */}
  <p className="text-xl font-serif text-gray-900 mb-1 tracking-wide">
    Shahzad Ahmad
  </p>

  {/* Line */}
  <div className="w-full h-[1px] bg-gray-300"></div>

  {/* Title */}
  <p className="text-[9px] text-gray-500 uppercase font-semibold tracking-[0.3em] mt-3">
    Founder & CEO
  </p>

</div>

  {/* QR BLOCK */}
  <div className="flex flex-col items-center">
    <div className="p-2 bg-white border border-gray-200 rounded shadow-sm">
      <QRCodeCanvas
       value={`https://genzevaluation.digital/verify-certificate/${fullCertificateId}`}
        size={95}
        level={"H"}
      />
    </div>

   <p className="text-[8px] font-mono font-semibold text-gray-500 mt-1 uppercase tracking-wide">
  Credential ID:{displayCertificateId}
</p>
   
  </div>

</div>
      </div>
    </div>
  );
};

export default CertificateGenerator;


















































